import axios from "axios";
import Cookies from "js-cookie";
import { TOKEN_NAME } from "../constants";

const Request = async (endpoint, opts) => {
  const { headers, ...options } = opts;
  const config = Object.assign(
    {
      url: endpoint,
      baseURL: process.env.REACT_APP_API_URI,
      headers: Object.assign(
        {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get(TOKEN_NAME)}`,
        },
        headers
      ),
      timeout: 60000,
    },
    options
  );
  try {
    const response = await axios.request(config);
    return { response: response.data || {} };
  } catch (error) {
    if (error.response) {
      return {
        error: Object.assign(error.response.data, {
          status: error.response.status || error.request?.status,
        }),
      };
    }
    if (error.request && error.request._response) {
      return { error: { message: error.request._response } };
    }
    return { error: { message: error.message } };
  }
}

export default Request;
